export const GRID_COLS = 10;
export const GRID_ROWS = 4014;
export const HOLE_RADIUS = 9;
export const CELL_W = 32;
export const CELL_H = 40;
export const PLAY_MARGIN_X = 20;
export const PLAY_MARGIN_TOP = 60;

export interface Hole {
  index: number;
  col: number;
  row: number;
  x: number;
  y: number;
}

export function generateHoles(): Hole[] {
  const holes: Hole[] = [];
  for (let row = 0; row < GRID_ROWS; row++) {
    const stagger = row % 2 === 1 ? CELL_W / 2 : 0;
    for (let col = 0; col < GRID_COLS; col++) {
      const x = PLAY_MARGIN_X + CELL_W / 2 + col * CELL_W + stagger;
      const y = PLAY_MARGIN_TOP + CELL_H / 2 + row * CELL_H;
      holes.push({ index: row * GRID_COLS + col, col, row, x, y });
    }
  }
  return holes;
}

export function findHole(holes: ReadonlyArray<Hole>, col: number, row: number): Hole {
  const h = holes.find(h => h.col === col && h.row === row);
  if (!h) throw new Error(`Hole at (${col},${row}) not found`);
  return h;
}
